export default "__VITE_ASSET__68495df7__"